import { useEffect } from 'react';
import { FUNC_TAB_VOD } from '@/pages/function/constants/index';

const useVodPopup = () => {
	const vodPopup = () => {
		const vodModal = document.querySelector('.popup');
		const vodLink = document.querySelectorAll<HTMLAnchorElement>('.vod-list a');
		const popupClose = document.querySelector('.popup-close');
		const iframe = document.querySelector('.popup .vod-wrap iframe') as HTMLIFrameElement | null;

		vodLink.forEach(link => {
			link.addEventListener('click', function (event: Event) {
				event.preventDefault();
				const listClass = document.querySelector('.function')?.classList[2] || '';
				const videoIndex = parseInt(link.getAttribute('data-index') || '0', 10);

				if (FUNC_TAB_VOD[listClass] && FUNC_TAB_VOD[listClass][videoIndex]) {
					const videoUrl = FUNC_TAB_VOD[listClass][videoIndex];
					if (iframe) {
						iframe.src = videoUrl;
					}
					vodModal?.classList.add('is-open');
				}
			});
		});

		popupClose?.addEventListener('click', function () {
			if (iframe) {
				iframe.src = '';
			}
			vodModal?.classList.remove('is-open');
		});
	};

	useEffect(() => {
		vodPopup();
		window.addEventListener('hashchange', vodPopup);
		return () => {
			window.addEventListener('hashchange', vodPopup);
		};
	}, []);
};

export default useVodPopup;
